export default __webpack_public_path__ + "static/media/date_bg.f2139e38.png";